var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessagesinbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_599_41169)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#5B1DEE"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_599_41169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0012 16.3125C21.0193 16.3123 20.054 16.5663 19.1994 17.0498C18.3448 17.5333 17.6299 18.2299 17.1243 19.0716C16.6187 19.9134 16.3397 20.8718 16.3144 21.8534C16.2891 22.835 16.5183 23.8064 16.9798 24.6731L16.3591 26.5352C16.3077 26.6894 16.3003 26.8549 16.3376 27.013C16.3749 27.1712 16.4556 27.3159 16.5705 27.4308C16.6854 27.5457 16.83 27.6263 16.9882 27.6637C17.1464 27.701 17.3118 27.6935 17.466 27.6421L19.3281 27.0214C20.0909 27.4271 20.936 27.6537 21.7995 27.684C22.6629 27.7143 23.5218 27.5475 24.3112 27.1963C25.1005 26.845 25.7994 26.3186 26.3549 25.6569C26.9104 24.9952 27.3079 24.2157 27.5171 23.3774C27.7263 22.5392 27.7419 21.6643 27.5625 20.8192C27.3831 19.9741 27.0136 19.1809 26.4819 18.5C25.9502 17.819 25.2704 17.2681 24.4941 16.889C23.7177 16.51 22.8652 16.3129 22.0012 16.3125ZM19.595 22.6562C19.4652 22.6562 19.3383 22.6178 19.2304 22.5457C19.1225 22.4735 19.0384 22.371 18.9887 22.2511C18.939 22.1312 18.926 21.9993 18.9514 21.872C18.9767 21.7447 19.0392 21.6277 19.131 21.536C19.2227 21.4442 19.3397 21.3817 19.467 21.3564C19.5943 21.331 19.7262 21.344 19.8461 21.3937C19.966 21.4434 20.0685 21.5275 20.1406 21.6354C20.2128 21.7433 20.2512 21.8702 20.2512 22C20.2512 22.174 20.1821 22.341 20.059 22.464C19.936 22.5871 19.769 22.6562 19.595 22.6562ZM22.0012 22.6562C21.8714 22.6562 21.7446 22.6178 21.6366 22.5457C21.5287 22.4735 21.4446 22.371 21.3949 22.2511C21.3453 22.1312 21.3323 21.9993 21.3576 21.872C21.3829 21.7447 21.4454 21.6277 21.5372 21.536C21.629 21.4442 21.7459 21.3817 21.8732 21.3564C22.0005 21.331 22.1325 21.344 22.2524 21.3937C22.3723 21.4434 22.4748 21.5275 22.5469 21.6354C22.619 21.7433 22.6575 21.8702 22.6575 22C22.6575 22.174 22.5884 22.341 22.4653 22.464C22.3422 22.5871 22.1753 22.6562 22.0012 22.6562ZM24.4075 22.6562C24.2777 22.6562 24.1508 22.6178 24.0429 22.5457C23.935 22.4735 23.8509 22.371 23.8012 22.2511C23.7515 22.1312 23.7385 21.9993 23.7639 21.872C23.7892 21.7447 23.8517 21.6277 23.9435 21.536C24.0352 21.4442 24.1522 21.3817 24.2795 21.3564C24.4068 21.331 24.5387 21.344 24.6586 21.3937C24.7785 21.4434 24.881 21.5275 24.9531 21.6354C25.0253 21.7433 25.0637 21.8702 25.0637 22C25.0637 22.174 24.9946 22.341 24.8715 22.464C24.7485 22.5871 24.5815 22.6562 24.4075 22.6562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0012 16.3125C21.0193 16.3123 20.054 16.5663 19.1994 17.0498C18.3448 17.5333 17.6299 18.2299 17.1243 19.0716C16.6187 19.9134 16.3397 20.8718 16.3144 21.8534C16.2891 22.835 16.5183 23.8064 16.9798 24.6731L16.3591 26.5352C16.3077 26.6894 16.3003 26.8549 16.3376 27.013C16.3749 27.1712 16.4556 27.3159 16.5705 27.4308C16.6854 27.5457 16.83 27.6263 16.9882 27.6637C17.1464 27.701 17.3118 27.6935 17.466 27.6421L19.3281 27.0214C20.0909 27.4271 20.936 27.6537 21.7995 27.684C22.6629 27.7143 23.5218 27.5475 24.3112 27.1963C25.1005 26.845 25.7994 26.3186 26.3549 25.6569C26.9104 24.9952 27.3079 24.2157 27.5171 23.3774C27.7263 22.5392 27.7419 21.6643 27.5625 20.8192C27.3831 19.9741 27.0136 19.1809 26.4819 18.5C25.9502 17.819 25.2704 17.2681 24.4941 16.889C23.7177 16.51 22.8652 16.3129 22.0012 16.3125ZM19.595 22.6562C19.4652 22.6562 19.3383 22.6178 19.2304 22.5457C19.1225 22.4735 19.0384 22.371 18.9887 22.2511C18.939 22.1312 18.926 21.9993 18.9514 21.872C18.9767 21.7447 19.0392 21.6277 19.131 21.536C19.2227 21.4442 19.3397 21.3817 19.467 21.3564C19.5943 21.331 19.7262 21.344 19.8461 21.3937C19.966 21.4434 20.0685 21.5275 20.1406 21.6354C20.2128 21.7433 20.2512 21.8702 20.2512 22C20.2512 22.174 20.1821 22.341 20.059 22.464C19.936 22.5871 19.769 22.6562 19.595 22.6562ZM22.0012 22.6562C21.8714 22.6562 21.7446 22.6178 21.6366 22.5457C21.5287 22.4735 21.4446 22.371 21.3949 22.2511C21.3453 22.1312 21.3323 21.9993 21.3576 21.872C21.3829 21.7447 21.4454 21.6277 21.5372 21.536C21.629 21.4442 21.7459 21.3817 21.8732 21.3564C22.0005 21.331 22.1325 21.344 22.2524 21.3937C22.3723 21.4434 22.4748 21.5275 22.5469 21.6354C22.619 21.7433 22.6575 21.8702 22.6575 22C22.6575 22.174 22.5884 22.341 22.4653 22.464C22.3422 22.5871 22.1753 22.6562 22.0012 22.6562ZM24.4075 22.6562C24.2777 22.6562 24.1508 22.6178 24.0429 22.5457C23.935 22.4735 23.8509 22.371 23.8012 22.2511C23.7515 22.1312 23.7385 21.9993 23.7639 21.872C23.7892 21.7447 23.8517 21.6277 23.9435 21.536C24.0352 21.4442 24.1522 21.3817 24.2795 21.3564C24.4068 21.331 24.5387 21.344 24.6586 21.3937C24.7785 21.4434 24.881 21.5275 24.9531 21.6354C25.0253 21.7433 25.0637 21.8702 25.0637 22C25.0637 22.174 24.9946 22.341 24.8715 22.464C24.7485 22.5871 24.5815 22.6562 24.4075 22.6562Z",
    stroke: "#202020",
    strokeWidth: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_599_41169",
    x: -9.53674e-7,
    y: -9.53674e-7,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_599_41169"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.733333 0 0 0 0 0.764706 0 0 0 0 0.807843 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_599_41169",
    result: "effect2_dropShadow_599_41169"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_599_41169",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_599_41169",
    x: 16.0625,
    y: 16.0625,
    width: 12.875,
    height: 12.875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_599_41169"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_599_41169",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesinbox);
export default __webpack_public_path__ + "static/media/messagesinbox.a85b5e6fd8ff9576cb7d600929239038.svg";
export { ForwardRef as ReactComponent };